import React from 'react';
import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';

const AllVibes = ({ playSong, songs, vibes }) => {
  // Sort vibes alphabetically
  const sortedVibes = [...vibes].sort((a, b) => a.name.localeCompare(b.name));

  const handlePlayVibe = (vibe) => {
    const vibeSongs = songs.filter(song => song.vibes.includes(vibe.id));
    if (vibeSongs.length > 0) {
      playSong(vibeSongs[0], vibeSongs);
    }
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <h1 className="page-title">All Vibes</h1>
        <p className="page-description">Discover all our mystical energy categories</p>
      </div>

      <div className="all-vibes-grid">
        {sortedVibes.map(vibe => {
          const vibeSongs = songs.filter(song => song.vibes.includes(vibe.id));
          
          return (
            <Link key={vibe.id} to={`/vibe/${vibe.id}`} className="all-vibe-card">
              <div 
                className="all-vibe-background"
                style={{ 
                  backgroundColor: vibe.color,
                  backgroundImage: vibe.image_url ? `url(${vibe.image_url})` : 'none',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              >
                <div className="all-vibe-overlay"></div>
                <div className="all-vibe-content">
                  <h3 className="all-vibe-name">{vibe.name}</h3>
                  <p className="all-vibe-description">{vibe.description}</p>
                  <div className="all-vibe-stats">
                    <span>{vibeSongs.length} songs</span>
                  </div>
                </div>
                <button 
                  className="all-vibe-play-button"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePlayVibe(vibe);
                  }}
                >
                  <Play size={20} fill="white" />
                </button>
              </div>
            </Link>
          );
        })}
      </div>

      {/* Popular Vibes Section */}
      <section className="content-section">
        <div className="section-header">
          <h2>Most Popular</h2>
          <p>The vibes our community loves most</p>
        </div>
        
        <div className="popular-vibes-list">
          {sortedVibes.slice(0, 3).map((vibe, index) => {
            const vibeSongs = songs.filter(song => song.vibes.includes(vibe.id));
            
            return (
              <Link key={vibe.id} to={`/vibe/${vibe.id}`} className="popular-vibe-item">
                <div className="popular-vibe-rank">#{index + 1}</div>
                <div 
                  className="popular-vibe-image"
                  style={{ backgroundColor: vibe.color }}
                >
                  <span>{vibe.name}</span>
                </div>
                <div className="popular-vibe-info">
                  <h4 className="popular-vibe-name">{vibe.name}</h4>
                  <p className="popular-vibe-description">{vibe.description}</p>
                  <span className="popular-vibe-count">{vibeSongs.length} songs</span>
                </div>
                <button 
                  className="popular-vibe-play"
                  onClick={(e) => {
                    e.preventDefault();
                    handlePlayVibe(vibe);
                  }}
                >
                  <Play size={16} />
                </button>
              </Link>
            );
          })}
        </div>
      </section>

      {/* Recently Added Vibes */}
      <section className="content-section">
        <div className="section-header">
          <h2>Recently Added</h2>
          <p>New vibes to explore</p>
        </div>
        
        <div className="recent-vibes-grid">
          {sortedVibes.slice(-2).map(vibe => {
            const vibeSongs = songs.filter(song => song.vibes.includes(vibe.id));
            
            return (
              <Link key={vibe.id} to={`/vibe/${vibe.id}`} className="recent-vibe-card">
                <div 
                  className="recent-vibe-background"
                  style={{ 
                    background: `linear-gradient(135deg, ${vibe.color}40, ${vibe.color}20)`,
                  }}
                >
                  <div className="recent-vibe-content">
                    <span className="new-badge">NEW</span>
                    <h3 className="recent-vibe-name">{vibe.name}</h3>
                    <p className="recent-vibe-description">{vibe.description}</p>
                    <span className="recent-vibe-count">{vibeSongs.length} songs</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default AllVibes;